// extracted by mini-css-extract-plugin
module.exports = {"mobileGalleryHeader":"TemplateGalleryMobile_mobileGalleryHeader__BA0Rv","mobileGalleryFooter":"TemplateGalleryMobile_mobileGalleryFooter__ZQKkB"};